import { useGlobalDefaultShoppingAddress } from '@/features/account/services/Addresses/hooks'
import { CaretDownIcon } from '@shipt/design-system-icons'
import styled from 'styled-components'
import { trackElementClicked } from '@/features/shared/analytics/element'
import { useIsGuestUser } from '@/features/account/services/User/hooks'
import { TextButton } from '@shipt/design-system-buttons'
import { useHandleDialog } from '@/features/shared/state/Dialog/useHandleDialog'
import { DynamicGlobalAddressModal } from '@/features/account/components/Modal/GlobalAddressModal/DynamicGlobalAddressModal'
import { DynamicGuestAddressModal } from '@/features/account/components/Modal/GuestAddressModal/DynamicGuestAddressModal'
import { Body, typographyAttributes } from '@shipt/design-system-typography'
import { Box, Column, Row } from '@shipt/design-system-layouts'
import { routes } from '@shared/constants/routes'
import { useZip } from '@/features/account/services/Zip/hooks'

export const AddressButton = ({ holidayGHP }: { holidayGHP?: boolean }) => {
  const { openDialog } = useHandleDialog()
  const isGuestUser = useIsGuestUser()
  const shoppingAddress = useGlobalDefaultShoppingAddress()
  const zip = useZip()

  const handleOnClick = () => {
    trackElementClicked({
      type: 'button',
      content: 'select_delivery_address',
      display_format: 'horizontal_list',
    })

    if (isGuestUser) {
      return openDialog(DynamicGuestAddressModal)
    }
    if (!shoppingAddress.street1) {
      openDialog(DynamicGlobalAddressModal, {
        contentLabel: 'Enter your delivery address',
        subheading: 'Item availability and price may vary by location.',
        hideSavedAddresses: true,
        destinationUrl: routes.GLOBAL_HOMEPAGE.url,
      })
    } else {
      openDialog(DynamicGlobalAddressModal)
    }
  }

  const shownLocation = shoppingAddress.street1 ?? zip

  return (
    <Box display={{ base: 'none', md: 'block' }}>
      <Column>
        <DeliverToText size="sm" $holidayGHP={holidayGHP}>
          Deliver to
        </DeliverToText>
        <Button
          onClick={handleOnClick}
          aria-label="Address button"
          {...typographyAttributes({ isPII: true })}
        >
          <Row align="center" justify="end" as="u">
            <AddressButtonText size="md" isPII $holidayGHP={holidayGHP}>
              {shownLocation}
            </AddressButtonText>
            <CaretDownIcon surface={holidayGHP ? 'inverse' : 'default'} />
          </Row>
        </Button>
      </Column>
    </Box>
  )
}

const Button = styled(TextButton)`
  white-space: nowrap;
`
const DeliverToText = styled(Body)<{ $holidayGHP?: boolean }>`
  color: ${({ theme, $holidayGHP }) =>
    $holidayGHP && theme.color.content.base.neutral.primary_inverse};
`

const AddressButtonText = styled(DeliverToText)`
  text-decoration: ${({ $holidayGHP }) => $holidayGHP && 'underline'};
`
